/* eslint-disable no-undef */
const Analytics = {
	reachGoal: (target) => {
		if (typeof window.ym === 'function') {
			window.ym(25538402, 'reachGoal', target);
		}
	},
	push: (event) => {
		if (typeof window.dataLayer === 'undefined') {
			window.dataLayer = [];
		}

		window.dataLayer.push(event);
	},
};

// Главная страница, верхняя кнопка
$('.stats-clickconnectmainpage1').on('click', () => {
	Analytics.reachGoal('clickconnectmainpage1');

	// ga('send', 'event', 'click', 'connect', 'mainpage1');
});

// Главная страница, средняя кнопка
$('.stats-clickconnectmainpage2').on('click', () => {
	Analytics.reachGoal('clickconnectmainpage2');

	// ga('send', 'event', 'click', 'connect', 'mainpage2');
});

// Страница Онлайн-оплата для общественного питания (Все кнопки подключить)
$('.stats-clickconnectfood').on('click', () => {
	Analytics.reachGoal('clickconnectfood');

	// ga('send', 'event', 'click', 'connect', 'food');
});

// Страница E-commerce (Все кнопки подключить)
$('.stats-clickconnectecommerce').on('click', () => {
	Analytics.reachGoal('clickconnectecommerce');

	// ga('send', 'event', 'click', 'connect', 'ecommerce');
});

// Онлайн платежи в финансах (Все кнопки подключить)
$('.stats-clickconnectfinance').on('click', () => {
	Analytics.reachGoal('clickconnectfinance');

	// ga('send', 'event', 'click', 'connect', 'finance');
});

// Платежный сервис для сферы развлечений (Все кнопки подключить)
$('.stats-clickconnectenvironment').on('click', () => {
	Analytics.reachGoal('clickconnectenvironment');

	// ga('send', 'event', 'click', 'connect', 'environment');
});

// Прием платежей для онлайн-образования (Все кнопки подключить)
$('.stats-clickconnecteducation').on('click', () => {
	Analytics.reachGoal('clickconnecteducation');

	// ga('send', 'event', 'click', 'connect', 'education');
});

// Агентам  (Все кнопки подключить)
$('.stats-clickconnect-agents').on('click', () => {
	Analytics.reachGoal('clickconnectagents');

	gtag('event', 'connect', {
		event_category: 'click',
		event_label: 'agents',
		value: 'value',
	});
});

// онлайн-магазин велосипедов bicycle-service.html отправка формы
$('.bicycle #request-simple').on('submit', () => {
	Analytics.reachGoal('velo-roll');
});

// Клик по номеру телефона
$('.stats-clickphone').on('click', () => {
	Analytics.reachGoal('clickphone');

	// ga('send', 'event', 'click', 'phone', 'label');
});

// Клик по почте
$('.stats-clickmail').on('click', () => {
	Analytics.reachGoal('clickmail');

	// ga('send', 'event', 'click', 'mail', 'label');
});

// Кнопка войти
$('.stats-clickloginsuccess').on('click', () => {
	Analytics.reachGoal('clickloginsuccess');

	// eslint-disable-next-line new-cap
	VK.Goal('login');

	// ga('send', 'event', 'clicklogin', 'success', 'label');
});

// Кнопка

export default {
	// start15SecTimeout,
	// virtualHit,
};
